// Export all design system constants from a single index file
export { ellucianColors } from './colors';
// export const marketplaceHeroImage = '/Marketplace-Hero_Higher Res.jpg';
export const marketplaceHeroImage = '/MarketplaceHeroHigherRes.jpg';

/** sessionStorage key for persisting filter/sort state across same-session navigation */
export const FILTER_STATE_KEY = 'marketplace_filter_state';